import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

export const DEFAULT_SEO = {
  site_name: "Drywall Local 675",
  site_url: "https://local675.org",
  default_title: "Drywall Local 675 | Drywall, Acoustic, Lathing & Insulation",
  title_suffix: " | Drywall Local 675",
  default_description:
    "Drywall Local 675 (UBCJA) represents drywall, acoustic, lathing and insulation trades members in the Greater Toronto Area. Office in Woodbridge, Ontario.",
  keywords: "Drywall Local 675, drywall union, acoustic, lathing, insulation, United Brotherhood of Carpenters, UBCJA, Woodbridge Ontario",
  og_image: "/og-image.jpg",
  robots_index: true,
  pages: { home: { title: "", description: "" }, contact: { title: "", description: "" }, events: { title: "", description: "" } },
  google_analytics_id: "",
  google_tag_manager_id: "",
  google_site_verification: "",
  bing_site_verification: "",
  head_html: "",
  body_start_html: "",
  footer_html: "",
};

export const DEFAULT_CONTENT = {
  seo: DEFAULT_SEO,
  loaded: false,
  logo_url: "https://customer-assets-rejwkqb3.emergentagent.net/job_ubcja-675-build/artifacts/awuja5t3_675DrywallAcousticLathingColour%20%5BConverted%5D-white2.webp",
  logo_backdrop: "none",
  hero_headline: "Something great\nis coming.",
  hero_subhead: "Drywall Local 675 is building a new home online. Check back soon.",
  hero_image: "https://images.pexels.com/photos/5493677/pexels-photo-5493677.jpeg",
  hero_video: "",
  about_text: "Drywall Local 675 represents members across the drywall, acoustic, and lathing/insulation trades as part of the United Brotherhood of Carpenters and Joiners of America.",
  marquee_text: "Drywall · Acoustic · Lathing · Insulation · United Brotherhood of Carpenters and Joiners of America · Local 675",
  footer_text: "© 2026 Drywall Local 675. Website launching soon.",
  home_events_count: 3,
  contact: {
    email: "info675@ubcja.ca",
    phone: "905-652-4140",
    address: "222 Rowntree Dairy Road, Woodbridge",
    hours: "8:00 AM–4:30 PM, Monday to Friday",
  },
  staff: [
    { role: "Dispatch", name: "Raffaela", phone: "905-652-4142", email: "rmastropietro@ubcja.ca" },
    { role: "Union Dues", name: "Sonia", phone: "905-851-7301", email: "salonzi@ubcja.ca" },
    { role: "Administrative Assistant", name: "Michelle", phone: "905-652-0533", email: "mbenko@ubcja.ca" },
    { role: "Administrative Assistant", name: "Sandra", phone: "905-652-0531", email: "spassafiume@ubcja.ca" },
    { role: "Executive Assistant", name: "Sandi", phone: "905-851-0991", email: "ssarra@ubcja.ca" },
  ],
  events: [
    { title: "Labour Day Parade", date: "Monday, September 7, 2026", time: "", location: "" },
    { title: "Local Meeting", date: "Monday, September 28, 2026", time: "7:00 PM", location: "Meeting Hall" },
    { title: "Local Meeting", date: "Monday, October 26, 2026", time: "7:00 PM", location: "Meeting Hall" },
    { title: "Local Meeting", date: "Monday, November 23, 2026", time: "7:00 PM", location: "Meeting Hall" },
    { title: "Children's Christmas Party", date: "Sunday, November 29, 2026", time: "", location: "Paramount Hall" },
  ],
  closures: [
    { title: "Office Closed", date: "Monday, September 7, 2026" },
    { title: "Office Closed", date: "Monday, October 12, 2026" },
  ],
};

const SiteContext = createContext({ content: DEFAULT_CONTENT, refresh: () => {} });

export function SiteProvider({ children }) {
  const [content, setContent] = useState(DEFAULT_CONTENT);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/content");
      setContent({ ...DEFAULT_CONTENT, ...data, seo: { ...DEFAULT_SEO, ...(data.seo || {}) }, loaded: true });
    } catch (e) {
      console.error("Failed to load site content", e);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SiteContext.Provider value={{ content, refresh }}>
      {children}
    </SiteContext.Provider>
  );
}

export function useSite() {
  return useContext(SiteContext);
}
